import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

export function DetailCard({
  title,
  children,
  style,
}: {
  title: string;
  children: ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        borderRadius: "12px",
        border: "1px solid #ECECEC",
        p: 3,
        ...style,
      }}
    >
      <Typography variant="h6" fontWeight={700} sx={{ fontSize: 18, mb: 2.5 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

export function DetailField({ label, value }: { label: string; value: ReactNode }) {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: 0.6,
          color: "text.secondary",
          textTransform: "uppercase",
          mb: 0.5,
        }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: 14, fontWeight: 500, color: "text.primary", lineHeight: 1.5 }}>{value}</Typography>
    </Box>
  );
}
